var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDka(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.228 9.003c-.922.767-1.965 1.7-2.642 2.326l-3.493-3.785c.717-.662 1.83-1.66 2.844-2.502A25.925 25.925 0 0 1 18.4 3.899a7.78 7.78 0 0 1 .722-.465c.126-.07.299-.158.5-.235.157-.06.546-.2 1.045-.2H30V21.99H19.113l-8.368-6.76H7.15v9.011h3.499l3.443-3.178 3.493 3.784-4.924 4.545H2V10.08h10.565l8.368 6.76h3.918V8.15h-3.542c-.282.204-.652.498-1.08.853z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDka);
export default __webpack_public_path__ + "static/media/DKA.19580c3d80fc35bf61aa5b8c2aae9ce1.svg";
export { ForwardRef as ReactComponent };